import React from 'react';

import useToggle from '@lyearn/core/hooks/useToggle';
import Responsive from '@/components/Responsive';

import { HeaderContextProvider } from '../context/HeaderContext';
import { DefaultHeaderProps } from '../types';
import DefaultHeaderDesktop from './index.desktop';
import DefaultHeaderMobile from './index.mobile';

const DefaultHeaderContainer = (props: DefaultHeaderProps) => {
  const [isSearchOpen, { on: showSearchBar, off: hideSearchBar, toggle: toggleSearchBar }] =
    useToggle();

  return (
    <HeaderContextProvider
      hideSearchBar={hideSearchBar}
      isSearchOpen={isSearchOpen}
      showSearchBar={showSearchBar}
      toggleSearchBar={toggleSearchBar}>
      <Responsive>
        <Responsive.Default>
          <DefaultHeaderDesktop {...props} />
        </Responsive.Default>
        <Responsive.Mobile>
          <DefaultHeaderMobile {...props} />
        </Responsive.Mobile>
      </Responsive>
    </HeaderContextProvider>
  );
};

export default DefaultHeaderContainer;
